import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/SearchPrivateTalentInfluencers.graphql';
import { Query, QuerysearchPrivateTalentInfluencersArgs } from '../../__generated__/globalTypes';

export const useSearchPrivateTalentInfluencersQuery = (
  options?: QueryHookOptions<Query, QuerysearchPrivateTalentInfluencersArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerysearchPrivateTalentInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useSearchPrivateTalentInfluencersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerysearchPrivateTalentInfluencersArgs>
): QueryResult<Query, QuerysearchPrivateTalentInfluencersArgs> & {
  getSearchPrivateTalentInfluencers: LazyQueryExecFunction<Query, QuerysearchPrivateTalentInfluencersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getSearchPrivateTalentInfluencers, result] = useLazyQuery<Query, QuerysearchPrivateTalentInfluencersArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getSearchPrivateTalentInfluencers, ...result };
};

export const useSearchPrivateTalentInfluencersPromiseQuery = () => {
  const client = useApolloClient();

  const getSearchPrivateTalentInfluencers = useCallback(
    (options?: Omit<QueryOptions<QuerysearchPrivateTalentInfluencersArgs, Query>, 'query'>) =>
      client.query<Query, QuerysearchPrivateTalentInfluencersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getSearchPrivateTalentInfluencers };
};
// Suspense Query Hooks
export const useSearchPrivateTalentInfluencersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerysearchPrivateTalentInfluencersArgs>
) => {
  const result = useSuspenseQuery<Query, QuerysearchPrivateTalentInfluencersArgs>(QUERY, {
    ...options
  });

  return result;
};
